import React from "react";
import "./TechStack.css";
import { Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

// Main component for Technology page
export default function TechStack() {
  return (
    <>
      {/* Tech Stack Banner Section */}
      <div className="stack-banner mx-auto">
        <h1 className="text-center text-white mb-4">Our Tech Stack</h1>

        {/* Navigation Links for Different Tech Stack Categories */}
        <Container className="text-center text-white d-flex align-items-center flex-column stack-container">
          <NavLink to="/explore-apps">APPs</NavLink>
          <NavLink to="/ExploreNetwork">Network Layer</NavLink>
          <NavLink to="/ExploreAPIs">Hybrid Stack Layer (Platform)</NavLink>
        {/*   <NavLink to="/explore-marketplace">Marketplaces</NavLink> */}
         {/*  <NavLink to="/ExploreNetwork">Networks</NavLink> */}
          <NavLink to="/ExploreAPIs">ANOS-Core Layer</NavLink>
          <NavLink to="/infrastructure">3rd Party Infrastructure</NavLink>
        </Container>
      </div>
    </>
  );
}
